import angular from 'angular';
import { limitServiceFactory } from './limitService.factory';

export const limitServiceModule = angular
  .module('bit.services.limitService', [])
  .factory('limitService', limitServiceFactory);
